<template>
    <div>
        <Titulo titulo="DIRECTORIO DE PERSONAL"/>

        <b-container>
            <b-row class="mt-5 mb-5">
                <b-col cols="12" xs="6" sm="4" md="3"
                    v-for="persona in directorio" 
                    :key="persona.id_directorio">
                    
                    <Persona 
                        :nombre="persona.nombre"
                        :foto="persona.foto"
                        :puesto="persona.puesto"
                        :telefono="persona.telefono"
                        :email="persona.email"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Titulo from '@/components/Titulo.vue'
import Persona from '@/components/Persona.vue'
import axios from 'axios'
import {mapState} from 'vuex'

export default {
    name: 'Directorio',
    props: {
    },
    components: {
        Titulo, Persona
    },
    data() {
        return {
            directorio: []
        }
    },
    created() {
        var formData = new FormData();
        formData.append("accion", "mostrarDatos");
        formData.append("tabla", "directorio");
        formData.append("ordenamiento", `nombre`);
        
        axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
        .then((res) => {
            this.directorio = res.data
        });
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>

</style>